(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxGoProfileList(
    $timeout, $http, GoProfileService, GoProfilePaging, OnDeviceConfigService, EventServiceEvents
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/printixGo/goProfileList/goProfileList.template.html',
      link: function(scope) {

        scope.paginationObject = new GoProfilePaging();
        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';

        (function() {
          getFirstPage();
          setListeners();
        })();

        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 12;
          scope.paginationObject.pagingCriteria.page = 0;
          scope.list = [];
          scope.loadingPage = true;
          GoProfileService.getGoProfilePaged(scope.paginationObject).then(function(printerSignInProfiles) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = printerSignInProfiles.page.totalPages;
            if (printerSignInProfiles.list) {
              scope.list = printerSignInProfiles.list;
            }
          }).catch(function(error) {});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            GoProfileService.getGoProfilePaged(scope.paginationObject).then(function(printerSignInProfiles){
              if (printerSignInProfiles.list) {
                scope.list = scope.list.concat(printerSignInProfiles.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.inline-scroll-utils').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 5;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.inline-scroll-utils').off('scroll');
        });


        ////////////////////////////////////
        ////////////////////////////////////
        //////  Open context menu
        ////////////////////////////////////
        scope.openContextMenu = function (event, context, menuOption){
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextPosition = { left: event.clientX, top: event.clientY }
            scope.context = context;
            scope.auxiliaries = {
              tenant: scope.tenant
            }
          }, 50)
        }

        scope.closeAllMenues = function () {
          scope.selectedContextMenuItem  =  null;
          scope.contextPosition = null;
          scope.context = null;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'statement':
                siteTooltip(position, context);
              break;
              case 'statement-fallback':
                toolTipFallback(position, context)
              break;
            }
          }
          else {
            scope.clearTooltip();
          }
        }

        function siteTooltip (position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: title,
            type: 'statement',
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LISTENERS
        ////////////////////////////////////////////
        function setListeners () {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_PRINTER_CREDENTIAL_DELETED, function(name, data) {
            for (var i = 0; i < scope.list.length; i++) {
              if (data.credential === scope.list[i].info._links.self.href) {
                getFirstPage();
              }
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_PRINTER_CREDENTIAL_CREATED, function(name, data) {
            getFirstPage();
          });

        }

      }
    };
  }

  pxGoProfileList.$inject = ['$timeout', '$http', 'GoProfileService', 'GoProfilePaging', 'OnDeviceConfigService', 'EventServiceEvents'];

  angular
    .module('printix-admin')
    .directive('pxGoProfileList', pxGoProfileList);

})();
